import { FEATURED_PRODUCTS_PAIR } from '../constants/constants';

/**
 * Returns the code of the product by its ID.
 *
 * @param productId
 * @return {*|null}
 */
export default (productId) => {
    return FEATURED_PRODUCTS_PAIR[productId]?.code || null;
}
